import { useState } from 'react';
import { vinScannerApi, VinScanResult } from '@/api/vinScanner';

export const useVinScanner = () => {
  const [isScanning, setIsScanning] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const scanImage = async (imageData: string): Promise<VinScanResult | null> => {
    setIsScanning(true);
    setError(null);

    try {
      const result = await vinScannerApi.scanImage(imageData);
      return result;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to scan image';
      setError(errorMessage);
      return null;
    } finally {
      setIsScanning(false);
    }
  };

  const clearError = () => {
    setError(null);
  };

  return {
    scanImage,
    isScanning,
    error,
    clearError
  };
};
